import {FC, useState} from 'react';
import Input from '@/shared/components/Inputs/Input';
import Button from '@/shared/components/Button';
import {BODY2, H6, SUBTITLE1} from '@/utils/constants';
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography} from '@mui/material';
import {ReactComponent as SearchIcon} from '@icons/search-normal.svg';
import {ReactComponent as PlusIcon} from '@icons/plus.svg';
import {ReactComponent as MinusIcon} from '@icons/minus.svg';
import {supportStyle} from './HelpAndSupport.styles';

const supportData = [
  //   {
  //     id: 0,
  //     title: "How do I get started with EventSimpli?",
  //     description:
  //       "Getting started is easy! Simply sign up for an account on our website and follow the intuitive setup process. You'll be creating and managing your fundraising events in no time.",
  //   },
  {
    id: 1,
    title: 'Is customer support available if I need assistance?',
    description:
      'Absolutely! We take pride in offering exceptional customer support. If you have any questions, encounter issues, or need guidance, our friendly support team is ready to assist you. Contact us through.',
  },
  {
    id: 2,
    title: 'Can I customize the look and feel of my event pages?',
    description:
      "Absolutely! With EventSimpli, you can showcase your events with beautifully designed and customizable event pages. Tailor the branding, images, and content to create a unique and professional representation of your organization's events.",
  },
  {
    id: 3,
    title: 'Is EventSimpli suitable for both virtual and in-person events?',
    description:
      "Yes! EventSimpli is designed to cater to a variety of event formats. Whether you're planning virtual events, in-person gatherings, or hybrid experiences, our platform adapts to your needs and provides the necessary tools for successful event management.",
  },
  {
    id: 4,
    title: 'What payment methods are supported for ticket sales and donations?',
    description:
      'EventSimpli integrates with popular payment gateways, allowing you to accept payments securely. You can enable credit card payments, PayPal, and other options to provide flexibility for your attendees and donors.',
  },
  {
    id: 5,
    title: 'Are there any fees associated with using EventSimpli?',
    description:
      'EventSimpli applies a nominal 1% transaction fee on all successful transactions made through the platform. This fee helps us maintain and improve the platform, ensuring a seamless and reliable experience for your fundraising efforts.',
  },
  {
    id: 6,
    title: 'Can I track the performance of my events?',
    description:
      'Yes! EventSimpli provides real-time analytics and detailed reports to give you insights into your event performance. Track ticket sales, attendee demographics, and other key metrics to make informed decisions and improve future events.',
  },
  {
    id: 7,
    title: 'Can I send email reminders and updates to my event attendees?',
    description:
      'Yes! EventSimpli includes built-in email communication features. Send automated event reminders, updates, and important announcements to keep your attendees informed and engaged throughout the event journey.',
  },
];

const HelpAndSupport: FC = () => {
  const emailTo = process.env.REACT_APP_EMAIL_TO;

  const [searchValue, setSearchValue] = useState('');
  const [expanded, setExpanded] = useState<number | false>(false);
  const handleChange = (panel: number) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  const filteredData = supportData.filter(
    (data) =>
      data.title.toLowerCase().includes(searchValue.toLowerCase()) ||
      data.description.toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleContactUs = () => {
    const subject = encodeURIComponent('EventSimply support request');
    window.location.href = `mailto:${emailTo}?subject=${subject}`;
  };

  return (
    <Box sx={supportStyle.wrapper}>
      <Box>
        <Typography sx={supportStyle.title} variant={H6}>
          Frequently Asked Questions
        </Typography>
        <Typography sx={supportStyle.afterTitle}>
          Need help with something? Here are our most frequently asked questions.
        </Typography>
        <Box sx={supportStyle.search}>
          <SearchIcon />
          <Input placeholder="Search for answers" value={searchValue} onChange={setSearchValue} />
        </Box>
        <Box sx={supportStyle.wrapperList}>
          {filteredData.map((data) => {
            return (
              <Accordion
                sx={supportStyle.wrapperItem}
                key={data.id}
                expanded={expanded === data.id}
                onChange={handleChange(data.id)}
              >
                <AccordionSummary
                  expandIcon={
                    expanded === data.id ? (
                      <MinusIcon style={expanded === data.id ? {stroke: 'var(--primary-500)'} : {}} />
                    ) : (
                      <PlusIcon />
                    )
                  }
                  aria-controls={data.title}
                  id={data.title}
                >
                  <Typography
                    sx={{
                      ...(expanded === data.id && supportStyle.accent),
                    }}
                    variant={SUBTITLE1}
                  >
                    {data.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant={BODY2}>{data.description}</Typography>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Box>
      </Box>
      <Box sx={supportStyle.buttonWrapper}>
        <Box>
          <Typography variant={SUBTITLE1}>Technical support</Typography>
          <Typography variant={BODY2} sx={supportStyle.text}>
            If you have some additional question, please contact our Help Center
          </Typography>
        </Box>

        <Button sx={supportStyle.button} title="Contact us" onClick={handleContactUs} />
      </Box>
    </Box>
  );
};

export default HelpAndSupport;
